import api from './axios';
import queryString from 'query-string';
import { Transaction, PaginatedResponse, TransactionFilterParams } from './types';

export const transactionApi = {
    getTransactions: async (params: TransactionFilterParams): Promise<PaginatedResponse<Transaction>> => {
        try {
            const response = await api.get('/transactions/transactions', {
                params,
                paramsSerializer: (params) => {
                    return queryString.stringify(params, { arrayFormat: 'none' as any, skipNull: true, skipEmptyString: true });
                }
            });
            return response.data;
        } catch (error) {
            console.error('Failed to fetch transactions:', error);
            throw error;
        }
    },

    getTransaction: async (id: string, business_id?: string): Promise<Transaction> => {
        try {
            const config = business_id ? { params: { business_id } } : {};
            const response = await api.get(`/transactions/transactions/${id}`, config);
            return response.data;
        } catch (error) {
            console.error('Failed to fetch transaction:', error);
            throw error;
        }
    },

    updateTransaction: async (id: string, data: Partial<Transaction>, business_id?: string): Promise<Transaction> => {
        try {
            const config = business_id ? { params: { business_id } } : {};
            const response = await api.put(`/transactions/transactions/${id}`, data, config);
            return response.data;
        } catch (error) {
            console.error('Failed to update transaction:', error);
            throw error;
        }
    },

    batchUpdateTransactions: async (transactionIds: string[], updates: Partial<Transaction>, business_id?: string): Promise<any> => {
        try {
            const config = business_id ? { params: { business_id } } : {};
            const response = await api.post('/transactions/transactions/batch-update', {
                transaction_ids: transactionIds,
                updates: updates
            }, config);
            return response.data;
        } catch (error) {
            console.error('Failed to batch update transactions:', error);
            throw error;
        }
    }
};

export default transactionApi;
